import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { ForbiddenComponent, NotFoundComponent } from '@ftr/ui-core'
import { CourtSystemForbiddenComponent } from '@ftr/ui-court-system'
import { DesktopLoginSplashComponent } from '@ftr/ui-desktop'
import { SupportedBrowsersModule } from '@ftr/ui-help'
import { ExternalLoginModule, LoggedInGuard, LoginModule } from '@ftr/ui-user'
import { CourtSystemForbiddenPage } from './court-system-forbidden.page'
import { DesktopLoginSplashPage } from './desktop-login-splash.page'
import { DesktopUpdateSplashPage } from './desktop-update-splash.page'
import { ExternalLoginPage } from './external-login.page'
import { ForbiddenPage } from './forbidden.page'
import { LoginPage } from './login.page'
import { LogoutPage } from './logout.page'
import { SupportedBrowsersPage } from './supported-browsers.page'

/**
 * Auth and public shell routes shared by ftr-web and ftr-admin (login, logout, help-adjacent public pages).
 */
@NgModule({
  imports: [
    LoginModule,
    SupportedBrowsersModule,
    ForbiddenComponent,
    NotFoundComponent,
    ExternalLoginModule,
    CourtSystemForbiddenComponent,
    DesktopLoginSplashComponent,
    CourtSystemForbiddenPage,
    RouterModule.forChild([
      {
        path: AppPaths.Login,
        component: LoginPage,
        canActivate: [LoggedInGuard],
        data: {
          title: 'Log In',
        },
      },
      {
        path: AppPaths.DesktopLoginSplash,
        component: DesktopLoginSplashPage,
        data: {
          title: 'Launching For The Record',
        },
      },
      {
        path: AppPaths.DesktopUpdateSplash,
        component: DesktopUpdateSplashPage,
        data: {
          title: 'App Version Out of Date',
        },
      },
      {
        path: AppPaths.Logout,
        component: LogoutPage,
      },
      {
        path: AppPaths.SupportedBrowsers,
        component: SupportedBrowsersPage,
        data: {
          title: 'Supported Browsers',
        },
      },
      {
        path: AppPaths.Forbidden,
        component: ForbiddenPage,
      },
      {
        path: AppPaths.NotFound,
        component: NotFoundComponent,
      },
      {
        path: AppPaths.ExternalLogin,
        component: ExternalLoginPage,
      },
      {
        path: AppPaths.CourtSystemForbidden,
        component: CourtSystemForbiddenPage,
      },
    ]),
  ],
  declarations: [
    LoginPage,
    DesktopLoginSplashPage,
    LogoutPage,
    SupportedBrowsersPage,
    ForbiddenPage,
    ExternalLoginPage,
  ],
  exports: [RouterModule],
})
export class SharedAuthRoutesModule {}
